export function PageLoader({ message = "Memuat data..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-gray-400">
      <div className="w-10 h-10 border-4 border-gray-200 border-t-primary-700 rounded-full animate-spin mb-4" />
      <p className="text-sm">{message}</p>
    </div>
  );
}

export function InlineLoader() {
  return (
    <div className="flex items-center gap-2 text-gray-400 text-sm">
      <div className="w-4 h-4 border-2 border-gray-200 border-t-primary-700 rounded-full animate-spin" />
      Memuat...
    </div>
  );
}

export function ButtonLoader() {
  return (
    <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
      />
    </svg>
  );
}
